import { useAuth } from "../../auth";

export const useUserRole = () => {
  const { user } = useAuth();

  if (!user) return null;

  if (user.is_pos_supervisor) return "supervisor";
  if (user.is_cashier) return "cashier";
  if (user.is_waiter) return "waiter";
  if (user.is_pos_user) return "pos_user"; // Optional fallback for basic POS user

  // Return null if no role matches
  return null;
};
